function assert(condition, message, exception) {
  if (process.env.__DEV__ === false) {
    return;
  }
  if (condition === true) {
    return;
  }

  console.log(`@Asssert : ${message} `);
  //throw exception(message);
  throw new exception(message);
}

export default assert;
